import React from 'react'

import { PriceString, ProfitString } from '@fourthwall/components'
import { SUMMARY_ROW_ID } from '@fourthwall/module-analytics'

import { TimezonedDateString } from '../../../../../../../../Timezone/components/TimezonedDateString'
import type { AnalyticsParams } from '../../../../../modules/AnalyticsParams'
import type { AnalyticsReportStatsTable } from '../AnalyticsReport.types'
import { getDateFormat } from './getDateFormat'

export const createChartStatsTableColumns = (
  params: AnalyticsParams,
): AnalyticsReportStatsTable<any>['columns'] => [
  {
    header: params.precision === 'HOUR' ? 'Time' : 'Day',
    render: (item) => {
      if (item.id === SUMMARY_ROW_ID) return item.day

      return (
        <TimezonedDateString
          date={item.day}
          format={getDateFormat(params.precision)}
          withTimezoneAbbreviation={false}
        />
      )
    },
  },
  { header: 'Transaction Value', render: (item) => <PriceString value={item.value} /> },
  { header: 'Cost', render: (item) => <PriceString value={item.cost} /> },
  { header: 'Contributions', render: (item) => item.contribution },
  { header: 'Profit', render: (item) => <ProfitString value={item.profit} /> },
]
